export const SET_USER_VALUE = "SET_USER_VALUE";
export const SET_USER_LOCATION = "SET_USER_LOCATION";
export const SET_USER_ERRORS = "SET_USER_ERRORS";
export const SET_REGISTERED_USER_DATA = "SET_REGISTERED_USER_DATA";

export const setUserInfo = (name, value) => ({
  type: SET_USER_VALUE,
  payload: {name, value}
});

export const setUserLocation = (name, value) => ({
  type: SET_USER_LOCATION,
  payload: {name, value}
});

export const setUserErrors = (name, errors = []) => ({
  type: SET_USER_ERRORS,
  payload: {name, errors}
});

export const setRegisteredUserData = (registeredUserEmail, registeredUserAuthToken) => ({
  type: SET_REGISTERED_USER_DATA,
  payload: {registeredUserEmail, registeredUserAuthToken}
});

export const replacePhoneToMatchMask = (phone) => {

  // return phone.replace(/^\(?(\d{3})\)?\s?(\d{3})\-?(\d+)$/, "($1) $2-$3") old mask, not replacing while typing

  // Remove all non-digit characters
  let cleaned = phone.replace(/\D/g, '');

  // Format as (xxx) xxx-xxxx as the user types
  if (cleaned.length > 0) {
    cleaned = `(${cleaned}`;
  }
  if (cleaned.length > 4) {
    cleaned = `${cleaned.slice(0, 4)}) ${cleaned.slice(4)}`;
  }
  if (cleaned.length > 9) {
    cleaned = `${cleaned.slice(0, 9)}-${cleaned.slice(9)}`;
  }

  // Update the input value with the formatted number
  return cleaned.slice(0, 14); // Maximum length is 14 including the formatting characters
}
export const replaceMaskToPassPhoneOnTheBackend = (phone) => {
  if (!phone) {
    return ""
  }
  return phone
    .replace(/ /g,"")
    .replace(/-/g,"")
    .replace(/\(/g,"")
    .replace(/\)/g,"")
}
